import * as React from "react"
import LogoSVG from "../images/logo.svg"
const Logo = () => (
	<h1 style={{ textAlign: "center", margin: "0" }}>
			<img
				id="logo"
				style={{ width: "95%", maxWidth: "500px", height: "auto" }}
				alt="Google Feud"
				src={LogoSVG}
			/>
	</h1>
)

export default Logo
